import {
  DEFAULT_SOUND_SETTINGS,
  type SoundSettings,
  normalizeSoundSettings,
} from '../services/SoundEngine';

export const SOUND_SETTINGS_STORAGE_KEY = 'automation-game-sound-settings';

export const applySoundSettingsDefaults = (
  partial?: Partial<SoundSettings>
): SoundSettings => {
  return normalizeSoundSettings({
    enabled: partial?.enabled ?? DEFAULT_SOUND_SETTINGS.enabled,
    masterVolume: partial?.masterVolume ?? DEFAULT_SOUND_SETTINGS.masterVolume,
    effectsVolume:
      partial?.effectsVolume ?? DEFAULT_SOUND_SETTINGS.effectsVolume,
    maxChannelsPerType:
      partial?.maxChannelsPerType ?? DEFAULT_SOUND_SETTINGS.maxChannelsPerType,
    maxDistance: partial?.maxDistance ?? DEFAULT_SOUND_SETTINGS.maxDistance,
    volumeFalloffStart:
      partial?.volumeFalloffStart ?? DEFAULT_SOUND_SETTINGS.volumeFalloffStart,
  });
};

export const loadSoundSettings = (): SoundSettings => {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return DEFAULT_SOUND_SETTINGS;
  }

  try {
    const raw = localStorage.getItem(SOUND_SETTINGS_STORAGE_KEY);
    if (!raw) {
      return DEFAULT_SOUND_SETTINGS;
    }

    const parsed = JSON.parse(raw) as Partial<SoundSettings>;
    return applySoundSettingsDefaults(parsed);
  } catch {
    return DEFAULT_SOUND_SETTINGS;
  }
};

export const saveSoundSettings = (settings: SoundSettings): void => {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return;
  }

  try {
    const normalized = applySoundSettingsDefaults(settings);
    localStorage.setItem(
      SOUND_SETTINGS_STORAGE_KEY,
      JSON.stringify(normalized)
    );
  } catch {
    // Ignore storage failures.
  }
};
